// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-measurements {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-measurements .page-title {
  margin-bottom: 0;
}

.page-measurements .page-title + .page-description {
  margin-top: 16px;
  margin-bottom: 24px;
}

.page-measurements .page-title + .measurement-section {
  margin-top: 32px;
}

.page-measurements form {
  width: 100%;
}

.page-measurements .inputs-container {
  padding: 0 47.5px;
  display: flex;
  flex-direction: row;
  width: 100%;
}

.page-measurements .input-container {
  position: relative;
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
}

.page-measurements .input-container + .input-container {
  margin-left: 21px;
}

.page-measurements .input-container input {
  height: 60px;
  width: 96px;
  background-color: transparent;
  outline: none;

  border-bottom: 2px solid var(--input-border-color);
  font-size: 48px;
  font-weight: 700;
  line-height: 48px;
  text-align: center;
}

.page-measurements .input-container .unit {
  display: inline-block;
  height: 60px;
  font-size: 22px;
  font-weight: 500;
  line-height: 70px;
}

.page-measurements .input-container input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.page-measurements .button-container {
  position: static;
  margin-top: 32px;
  width: 100%;
  box-sizing: border-box;
  max-width: 269px;
}

.page-measurements .error-message {
  margin-top: 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/base.measurements.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,aAAa;;EAEb,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".page-measurements {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.page-measurements .page-title {\n  margin-bottom: 0;\n}\n\n.page-measurements .page-title + .page-description {\n  margin-top: 16px;\n  margin-bottom: 24px;\n}\n\n.page-measurements .page-title + .measurement-section {\n  margin-top: 32px;\n}\n\n.page-measurements form {\n  width: 100%;\n}\n\n.page-measurements .inputs-container {\n  padding: 0 47.5px;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n}\n\n.page-measurements .input-container {\n  position: relative;\n  flex: 1;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.page-measurements .input-container + .input-container {\n  margin-left: 21px;\n}\n\n.page-measurements .input-container input {\n  height: 60px;\n  width: 96px;\n  background-color: transparent;\n  outline: none;\n\n  border-bottom: 2px solid var(--input-border-color);\n  font-size: 48px;\n  font-weight: 700;\n  line-height: 48px;\n  text-align: center;\n}\n\n.page-measurements .input-container .unit {\n  display: inline-block;\n  height: 60px;\n  font-size: 22px;\n  font-weight: 500;\n  line-height: 70px;\n}\n\n.page-measurements .input-container input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.page-measurements .button-container {\n  position: static;\n  margin-top: 32px;\n  width: 100%;\n  box-sizing: border-box;\n  max-width: 269px;\n}\n\n.page-measurements .error-message {\n  margin-top: 16px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
